import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contextProviders/AuthProvider";
import { useUserProfile } from "../contextProviders/UserProfileProvider";
import { Avatar, Typography, Popover, Menu , theme } from "antd";
import { LogoutOutlined, SettingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { translate } from "../helpers/translationHelper";
import { TRANSLATIONS } from "../constants/translations";
import { getInitials } from "../helpers/avatarHelper";

const { Text } = Typography;

const UserProfile: React.FC = () => {
  const { token } = theme.useToken();
  const { userName, logout } = useAuth();
  const { userProfile } = useUserProfile();
  const displayName = userProfile?.displayName;
  const photoUrl = userProfile?.photoUrl;
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!userName) {
    return null; // If no user data is available, don't render anything
  }

  const shownName = displayName || userName;

  const handleLogout = () => {
    logout();
  };

  // Menu items for the Popover -- "Perfil de anfitrión" now lives inside
  // Configuración as one more section (see Settings.tsx/HostProfileSection),
  // so it no longer needs its own entry here.
  const menu = (
    <Menu>
      <Menu.Item key="settings" icon={<SettingOutlined />} onClick={() => navigate("/settings")}>
        {translate(t, TRANSLATIONS.SETTINGS)}
      </Menu.Item>
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        {translate(t, TRANSLATIONS.LOGOUT)}
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Avatar
        src={photoUrl || undefined}
        size={40}
        onClick={() => navigate("/profile")}
        style={{
          marginRight: 10,
          cursor: "pointer",
          ...(photoUrl ? {} : { backgroundColor: token.colorPrimary }),
        }}
      >
        {!photoUrl && getInitials(shownName)}
      </Avatar>

      {/* Popover with userName and menu items */}
      <Popover content={menu} trigger={["hover", "click"]} placement="bottom">
        <Text
          style={{
            cursor: "pointer",
            maxWidth: 140,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "inline-block",
          }}
        >
          {shownName}
        </Text>
      </Popover>
    </div>
  );
};

export default UserProfile;
